import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
// import Link from 'next/link';
import Button from '@/components/Button';
import Tooltip from '@/components/Tooltip';
import ClientOnly from '@/components/ClientOnly';
import Breadcrumbs from '@/components/navigation/Breadcrumbs';
import { advertising } from '@/config/monetization';
import GroupedStarReviews from '@/components/reviews/GroupedStarReviews';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";

var GiftIcon = function GiftIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M4 12H20V17C20 19.2091 18.2091 21 16 21H8C5.79086 21 4 19.2091 4 17V12ZM6 14V17C6 18.1046 6.89543 19 8 19H16C17.1046 19 18 18.1046 18 17V14H6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M3 10C3 8.34315 4.34315 7 6 7H18C19.6569 7 21 8.34315 21 10V11C21 12.6569 19.6569 14 18 14H6C4.34315 14 3 12.6569 3 11V10ZM6 9C5.44772 9 5 9.44772 5 10V11C5 11.5523 5.44772 12 6 12H18C18.5523 12 19 11.5523 19 11V10C19 9.44772 18.5523 9 18 9H6Z",
      fill: "#12131A"
    }), /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M7 6C7 4.34315 8.34315 3 10 3C10.7684 3 11.4692 3.28885 12 3.76389C12.5308 3.28885 13.2316 3 14 3C15.6569 3 17 4.34315 17 6C17 7.65685 15.6569 9 14 9H13V21H11V9H10C8.34315 9 7 7.65685 7 6ZM11 7V6C11 5.44772 10.5523 5 10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7H11ZM13 6V7H14C14.5523 7 15 6.55228 15 6C15 5.44772 14.5523 5 14 5C13.4477 5 13 5.44772 13 6Z",
      fill: "#12131A"
    })]
  }));
};

GiftIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var CheckIcon = function CheckIcon(props) {
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M17.7071 8.29289C18.0976 8.68342 18.0976 9.31658 17.7071 9.70711L10 17.4142L6.29289 13.7071C5.90237 13.3166 5.90237 12.6834 6.29289 12.2929C6.68342 11.9024 7.31658 11.9024 7.70711 12.2929L10 14.5858L16.2929 8.29289C16.6834 7.90237 17.3166 7.90237 17.7071 8.29289Z",
      fill: "#12131A"
    })
  }));
};

CheckIcon.defaultProps = {
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var InfoIcon = function InfoIcon(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M10 0C4.47715 0 0 4.47715 0 10C0 15.5228 4.47715 20 10 20C15.5228 20 20 15.5228 20 10C20 4.47715 15.5228 0 10 0Z",
      fill: "#D8DAE6"
    }), /*#__PURE__*/_jsx("path", {
      d: "M10 5C9.44772 5 9 5.44772 9 6C9 6.55228 9.44772 7 10 7C10.5523 7 11 6.55228 11 6C11 5.44772 10.5523 5 10 5Z",
      fill: "#696C80"
    }), /*#__PURE__*/_jsx("path", {
      d: "M11 10C11 9.44772 10.5523 9 10 9C9.44772 9 9 9.44772 9 10V14C9 14.5523 9.44772 15 10 15C10.5523 15 11 14.5523 11 14V10Z",
      fill: "#696C80"
    })]
  }));
};

InfoIcon.defaultProps = {
  width: "20",
  height: "20",
  viewBox: "0 0 20 20",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const CalculatorHero = _ref => {
  let {
    elementId,
    heading,
    description,
    breadcrumbs = [],
    ctaText,
    ctaButtonIcon,
    ctaDisabled = false,
    featuredImgAlt,
    featuredImgSrcsets,
    features,
    reviews = [],
    onClick = () => undefined,
    onReviewsClick = () => undefined
  } = _ref;
  let ctaIcon = null;

  if (ctaButtonIcon === 'gift') {
    ctaIcon = /*#__PURE__*/_jsx(GiftIcon, {});
  }

  return /*#__PURE__*/_jsx("section", _objectSpread(_objectSpread({}, elementId && {
    id: elementId
  }), {}, {
    className: "-bgc-white",
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.container,
      children: [/*#__PURE__*/_jsx("aside", {
        className: styles.aside,
        children: /*#__PURE__*/_jsx(FeaturedImage, {
          featuredImgSrcsets: featuredImgSrcsets,
          featuredImgAlt: featuredImgAlt
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: styles.main,
        children: [/*#__PURE__*/_jsxs("header", {
          className: styles.header,
          children: [breadcrumbs.length && /*#__PURE__*/_jsx(Breadcrumbs, {
            list: breadcrumbs,
            className: styles.breadcrumbs
          }), /*#__PURE__*/_jsx("h1", {
            className: styles.heading,
            children: heading
          }), /*#__PURE__*/_jsx("p", {
            className: styles.description,
            children: description
          })]
        }), /*#__PURE__*/_jsxs("div", {
          className: styles.actions,
          children: [ctaText ? /*#__PURE__*/_jsx(Button, _objectSpread(_objectSpread({
            size: "large",
            type: "button",
            className: styles.actions__ctaButton,
            disabled: ctaDisabled,
            onClick: onClick
          }, ctaIcon && {
            rightIcon: ctaIcon
          }), {}, {
            children: ctaText
          })) : /*#__PURE__*/_jsx(_Fragment, {}), reviews.length ? /*#__PURE__*/_jsx(ClientOnly, {
            children: /*#__PURE__*/_jsx(GroupedStarReviews, {
              reviews: reviews,
              onClick: onReviewsClick
            })
          }) : /*#__PURE__*/_jsx(_Fragment, {})]
        }), /*#__PURE__*/_jsx("ul", {
          className: styles.featureBuckets,
          children: features.map((feature, i) => {
            const {
              tooltip
            } = feature;
            return /*#__PURE__*/_jsxs("li", {
              className: styles.featureBuckets__item,
              children: [/*#__PURE__*/_jsx(CheckIcon, {
                className: styles.featureBuckets__item__checkIcon
              }), ' ', /*#__PURE__*/_jsx("span", {
                className: styles.featureBuckets__item__text,
                children: feature.text
              }), tooltip ? /*#__PURE__*/_jsx(Tooltip, {
                placement: i > 1 ? 'left' : 'bottom',
                content: tooltip,
                children: /*#__PURE__*/_jsx(InfoIcon, {
                  className: styles.featureBuckets__item__infoIcon
                })
              }) : /*#__PURE__*/_jsx(_Fragment, {})]
            }, `hero-calc-feature-${i}`);
          })
        }), advertising.active && /*#__PURE__*/_jsx(ClientOnly, {
          children: /*#__PURE__*/_jsxs("div", {
            className: styles.advertisement,
            children: [/*#__PURE__*/_jsx("ins", {
              className: "adsbygoogle",
              style: {
                display: 'block'
              },
              "data-ad-client": "ca-pub-4288864228810491",
              "data-ad-slot": "6702656445",
              "data-ad-format": "auto",
              "data-full-width-responsive": "true"
            }), /*#__PURE__*/_jsxs("script", {
              children: ["(adsbygoogle = window.adsbygoogle || []).push(", ");"]
            })]
          })
        })]
      })]
    })
  }));
};

export default CalculatorHero;

const FeaturedImage = _ref2 => {
  let {
    featuredImgSrcsets,
    featuredImgAlt
  } = _ref2;
  const defaultSrc = ((featuredImgSrcsets[0] || {}).src || '').split(' ')[0];
  return /*#__PURE__*/_jsxs("picture", {
    children: [featuredImgSrcsets.map((_ref3, i) => {
      let {
        src,
        size
      } = _ref3;
      return /*#__PURE__*/_jsx("source", {
        srcSet: src,
        media: size
      }, `hero-calc-featured-img-${i}`);
    }), /*#__PURE__*/_jsx("img", {
      src: defaultSrc,
      alt: featuredImgAlt
    })]
  });
};